export default "__VITE_ASSET__44805373__"